export interface ColumnsHeaderType {
  regEx: RegExp;
  key: string;
  label: string;
  require?: boolean;
  isMatch?: boolean;
  position: number;
}

const SHIPPER_COLUMNS_HEADER: ColumnsHeaderType[] = [
  {
    regEx: /^(shipper|s) Name/i,
    key: 'shipperName',
    label: 'Shipper Name',
    require: true,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Company/i,
    key: 'shipperCompany',
    label: 'Shipper Company',
    require: false,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Country Telephone Code/i,
    key: 'shipperCountryCode',
    label: 'Shipper Country Telephone Code',
    require: true,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Contact Number/i,
    key: 'shipperContactNumber',
    label: 'Shipper Contact Number',
    require: true,
    position: 0,
  },

  {
    regEx: /^(shipper|s) Address Line 1/i,
    key: 'shipperAddressLine1',
    label: 'Shipper Address Line 1',
    require: true,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Address Line 2/i,
    key: 'shipperAddressLine2',
    label: 'Shipper Address Line 2',
    require: false,
    position: 0,
  },
  {
    regEx: /^(shipper|s) City/i,
    key: 'shipperCity',
    label: 'Shipper City',
    require: true,
    position: 0,
  },
  {
    regEx: /^(shipper|s) State/i,
    key: 'shipperState',
    label: 'Shipper State',
    require: false,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Country/i,
    key: 'shipperCountry',
    label: 'Shipper Country',
    require: true,
    position: 0,
  },
  {
    regEx: /^(shipper|s) Pincode/i,
    key: 'shipperPincode',
    label: 'Shipper Pincode',
    require: true,
    position: 0,
  },
];

const CONSIGNEE_COLUMNS_HEADER: ColumnsHeaderType[] = [
  {
    regEx: /^(consignee|c) Name/i,
    key: 'consigneeName',
    label: 'Consignee Name',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Company/i,
    key: 'consigneeCompany',
    label: 'Consignee Company',
    require: false,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Email/i,
    key: 'consigneeEmail',
    label: 'Consignee Email',
    require: false,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Country Telephone Code/i,
    key: 'consigneeCountryCode',
    label: 'Consignee Country Telephone Code',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Contact Number/i,
    key: 'consigneeContactNumber',
    label: 'Consignee Contact Number',
    require: true,
    position: 0,
  },

  {
    regEx: /^(consignee|c) Address Line 1/i,
    key: 'consigneeAddressLine1',
    label: 'Consignee Address Line 1',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Address Line 2/i,
    key: 'consigneeAddressLine2',
    label: 'Consignee Address Line 2',
    require: false,
    position: 0,
  },
  {
    regEx: /^(consignee|c) City/i,
    key: 'consigneeCity',
    label: 'Consignee City',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) State/i,
    key: 'consigneeState',
    label: 'Consignee State',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Country/i,
    key: 'consigneeCountry',
    label: 'Consignee Country',
    require: true,
    position: 0,
  },
  {
    regEx: /^(consignee|c) Pincode/i,
    key: 'consigneePincode',
    label: 'Consignee Pincode',
    require: true,
    position: 0,
  },
];

const SHIPMENT_INFO_COLUMNS_HEADER: ColumnsHeaderType[] = [
  {
    regEx: /^Shipment Type/i,
    key: 'shipmentType',
    label: 'Shipment Type (Parcel / Document)',
    require: true,
    position: 0,
  },
  {
    regEx: /^Shipment Mode/i,
    key: 'shipmentMode',
    label: 'Shipment Mode',
    require: true,
    position: 0,
  },
  {
    regEx: /packaging/i,
    key: 'packaging',
    label: 'Packaging (Yes/No)',
    require: false,
    position: 0,
  },
  {
    regEx: /insurance/i,
    key: 'insurance',
    label: 'Insurance (Yes/No)',
    require: false,
    position: 0,
  },
  {
    regEx: /^(invoice) number/i,
    key: 'invoiceNumber',
    label: 'Invoice Number',
    require: false,
    position: 0,
  },
  {
    regEx: /currency/i,
    key: 'currency',
    label: 'Currency',
    require: true,
    position: 0,
  },
  {
    regEx: /^unit of measurement/i,
    key: 'unitOfMeasurement',
    label: 'Unit Of Measurement (kg/lb)',
    require: true,
    position: 0,
  },
  {
    regEx: /reference number/i,
    key: 'referenceNumber',
    label: 'Reference Number',
    require: false,
    position: 0,
  },
  {
    regEx: /^duty & tax billed/i,
    key: 'dutyCharge',
    label: 'Duty & Tax Billed (DDU / DDP)',
    require: false,
    position: 0,
  },
  {
    regEx: /^incoterm/i,
    key: 'incoterm',
    label: 'Incoterm (FOB / CIF / CNF)',
    require: false,
    position: 0,
  },
  {
    regEx: /^freight/i,
    key: 'freight',
    label: 'Freight',
    require: false,
    position: 0,
  },
  {
    regEx: /^(freight insurance|freight_insurance|freightinsurance)/i,
    key: 'freightInsurance',
    label: 'Freight Insurance',
    require: false,
    position: 0,
  },
  {
    regEx: /^(purpose of shipment|shipment purpose|purpose)/i,
    key: 'purposeOfShipment',
    label: 'Purpose of Shipment',
    require: false,
    position: 0,
  },
  {
    regEx: /^(ioss number|ioss no|ioss_number|ioss)/i,
    key: 'iossNumber',
    label: 'IOSS Number',
    require: false,
    position: 0,
  },
  {
    regEx: /^(recipient vat|recipient tax id|recipient vat\/tax id|recipient vat \/ tax id|vat\/tax id|tax id)/i,
    key: 'recipientVatTaxId',
    label: 'Recipient VAT / Tax ID',
    require: false,
    position: 0,
  },
  {
    regEx: /^(ior\/eori|ior \/ eori|ior eori|ior|eori)/i,
    key: 'iorEoriNumber',
    label: 'IOR / EORI No.',
    require: false,
    position: 0,
  },
];

const BOX_INFO_HEADER_COLUMNS: ColumnsHeaderType[] = [
  {
    regEx: /^box no/i,
    key: 'boxNo',
    label: 'Box No',
    require: true,
    position: 0,
  },
  {
    regEx: /^duplicate boxes/i,
    key: 'duplicateBoxes',
    label: 'Duplicate Boxes',
    position: 0,
  },
  {
    regEx: /^weight/i,
    key: 'weight',
    label: 'Weight',
    require: true,
    position: 0,
  },

  {
    regEx: /length/i,
    key: 'length',
    label: 'Length',
    position: 0,
  },
  {
    regEx: /width/i,
    key: 'width',
    label: 'Width',
    position: 0,
  },
  {
    regEx: /height/i,
    key: 'height',
    label: 'Height',
    position: 0,
  },
];

const PRODUCT_INFO_HEADER_COLUMNS: ColumnsHeaderType[] = [
  {
    regEx: /product description/i,
    key: 'description',
    label: 'Product Description',
    require: true,
    position: 0,
  },
  {
    regEx: /product quantity/i,
    key: 'quantity',
    label: 'Product Quantity',
    require: true,
    position: 0,
  },
  {
    regEx: /product unit value/i,
    key: 'value',
    label: 'Product Unit Value',
    require: true,
    position: 0,
  },

  {
    regEx: /^(product hsn name|commodity code)/i,
    key: 'HSNName',
    label: 'Product HSN Name',
    require: false,
    position: 0,
  },
  {
    regEx: /^(product hsn code|hsn code)/i,
    key: 'HSNCode',
    label: 'Product HSN Code',
    require: false,
    position: 0,
  },
  {
    regEx: /^(product id|product_id|productid|sku)/i,
    key: 'productId',
    label: 'Product ID',
    require: false,
    position: 0,
  },
  {
    regEx: /^(product id type|product_id_type|productidtype)/i,
    key: 'productIdType',
    label: 'Product ID Type',
    require: false,
    position: 0,
  },
  {
    regEx: /^(merchant product id|merchant_product_id|merchantproductid|merchant id|m-pid)/i,
    key: 'merchantProductId',
    label: 'Merchant ID (M-PID)',
    require: false,
    position: 0,
  },
  {
    regEx:
      /^(standard manufacturer product id|standard_manufacturer_product_id|std mfr product id|standardmanufacturerproductid|barcode|s-pid)/i,
    key: 'standardManufacturerProductId',
    label: 'Barcode (S-PID)',
    require: false,
    position: 0,
  },
  {
    regEx:
      /^(non-?standard manufacturer product id|non_standard_manufacturer_product_id|non-?std mfr product id|nonstandardmanufacturerproductid|manufacturer part no|manufacturer part number|ns-pid)/i,
    key: 'nonStandardManufacturerProductId',
    label: 'Manufacturer part no. (NS-PID)',
    require: false,
    position: 0,
  },
  {
    regEx:
      /^(cpsc being sold|item being sold|being sold|is item being sold|needs? us safety certificate|does it need a us safety certificate|gcc or cpc)/i,
    key: 'cpscBeingSold',
    label: 'Does it need a US safety certificate (GCC or CPC)? (Yes/No)',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc disclaim code|disclaim code)/i,
    key: 'cpscDisclaimCode',
    label: 'CPSC Disclaim Code',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc additional context|additional context)/i,
    key: 'cpscAdditionalContext',
    label: 'CPSC Additional Context',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc certificate filed|certificate filed|is certificate filed)/i,
    key: 'cpscCertificateFiled',
    label: 'CPSC Certificate Filed (Yes/No)',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc product id registry|product id registry)/i,
    key: 'cpscProductIdRegistry',
    label: 'CPSC Product ID (Registry)',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc certificate version id|certificate version id)/i,
    key: 'cpscCertificateVersionId',
    label: 'CPSC Certificate Version ID',
    require: false,
    position: 0,
  },
  {
    regEx: /^(cpsc certifier id|certifier id)/i,
    key: 'cpscCertifierId',
    label: 'CPSC Certifier ID',
    require: false,
    position: 0,
  },
];
const COLUMNS_HEADER: ColumnsHeaderType[] = [
  SHIPPER_COLUMNS_HEADER,
  CONSIGNEE_COLUMNS_HEADER,
  SHIPMENT_INFO_COLUMNS_HEADER,
  BOX_INFO_HEADER_COLUMNS,
  PRODUCT_INFO_HEADER_COLUMNS,
]
  .flat(1)
  .map((x, i) => ({ ...x, position: i }));
export {
  SHIPPER_COLUMNS_HEADER,
  CONSIGNEE_COLUMNS_HEADER,
  SHIPMENT_INFO_COLUMNS_HEADER,
  BOX_INFO_HEADER_COLUMNS,
  PRODUCT_INFO_HEADER_COLUMNS,
  COLUMNS_HEADER,
};
